import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/auth/context'
import { FullScreenSpinner } from '@/auth/guards'
import { landingPath } from '@/auth/roles'
import { UpdatePrompt } from './pwa/UpdatePrompt'

export function Root() {
  return (
    <>
      <UpdatePrompt />
      <Outlet />
    </>
  )
}

/**
 * "/" decides the surface. A device already set up as a phone opens the phone even when the
 * online token has expired (the phone works on PINs); everyone else follows their roles.
 */
export function Landing() {
  const { status, roles } = useAuth()
  if (status === 'loading') return <FullScreenSpinner />
  if (status === 'anonymous') {
    return localStorage.getItem('ucsc.surface') === 'phone' ? (
      <Navigate to="/m" replace />
    ) : (
      <Navigate to="/login" replace />
    )
  }
  return <Navigate to={landingPath(roles)} replace />
}

/** Remember that this browser is a phone, so "/" goes straight to the PIN screen. */
export function MarkPhoneSurface() {
  try {
    localStorage.setItem('ucsc.surface', 'phone')
  } catch {
    /* ignore */
  }
  return <Outlet />
}
